// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const cadastrarGrupoService = async (data: any) => {
  const URL = `${Globais.DOMINIOBACK}/grupo`;
  try {
    const response = await axios.post(URL, data);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
